/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
// Material-UI components
import Typography from '@mui/material/Typography';
// custom components
import CommentCountCard from './CommentCountCard';
import EmptyCommentsCard from './EmptyCommentsCard';

function CommentsOverview({ commentSummary, resource = 'course' }) {
  const allZero = Object.values(commentSummary).every((value) => value === 0);

  const singularResource = (() => {
    switch (resource) {
      case 'courses':
        return 'course';
      case 'lessons':
        return 'lesson';
      case 'sections':
        return 'section';
      case 'pages':
        return 'page';
      default:
        return resource; // Fallback if resource doesn't match any case
    }
  })();

  if (!commentSummary || allZero) {
    return <EmptyCommentsCard resource={singularResource} />;
  }

  return (
    <div className="w-full flex grid grid-cols-3 divide-x-2">
      <CommentCountCard
        status="Pending"
        variant="text-blue-950"
        count={commentSummary['pending']}
        icon="heroicons-outline:dots-circle-horizontal"
      />
      <CommentCountCard
        status="Approved"
        variant="text-green-600"
        count={commentSummary['approved']}
        icon="heroicons-outline:check-circle"
      />
      <CommentCountCard
        status="Issues"
        variant={commentSummary['disapproved'] > 0 ? "text-red-600" : "text-blue-950"}
        count={commentSummary['disapproved']}
        icon="heroicons-outline:exclamation-circle"
      />
    </div>
  );
}

export default CommentsOverview;
